import './home.css';
import {useEffect, useRef, useState} from 'react';

const images: string[] = [
  "https://hshs-1320941338.cos.ap-nanjing.myqcloud.com/image1.png",
  "https://hshs-1320941338.cos.ap-nanjing.myqcloud.com/image2.png",
  "https://hshs-1320941338.cos.ap-nanjing.myqcloud.com/image3.png",
  "https://hshs-1320941338.cos.ap-nanjing.myqcloud.com/image4.png"
];

const tags: string[] = ['公司简介', '企业文化', '项目案例一', '项目案例二'];

const Home: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const sectionRefs = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const index = sectionRefs.current.findIndex(
        (ref) => ref && ref.offsetTop <= scrollY && (ref.offsetTop + ref.offsetHeight) > scrollY
      );
      setCurrentIndex(index !== -1 ? index : 0);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // const handleClick = (index: number) => {
  //   sectionRefs.current[index]?.scrollIntoView({ behavior: 'smooth' });
  // };

  const handleClick = (index: number) => {
    sectionRefs.current[index]?.scrollIntoView({behavior: 'smooth', block: 'start'});
  };

  return (
    <div>
      <div className='header'>
        {tags.map((tag, index) => (
          <div
            key={index}
            className={`tag ${currentIndex === index ? 'active' : ''}`}
            onClick={() => handleClick(index)}
          >
            {tag}
          </div>
        ))}
      </div>

      {images.map((src, index) => (
        <div
          key={index}
          className='image'
          ref={(el) => sectionRefs.current[index] = el}
        >
          <img src={src} alt={`Slide ${index + 1}`}/>
        </div>
      ))}

      <footer>
        <a style={{
          marginRight:'10px'
        }} href="https://beian.miit.gov.cn" target="_blank" rel="noreferrer">
          沪ICP备2023032485号-1
        </a>
        <a href="http://www.beian.gov.cn/portal/registersystemInfo?recordcode=31010782887953" target="_blank" rel="noreferrer">
          沪公网安备31010702007953号
        </a>
      </footer>
    </div>
  );
};

export default Home;
